import { ReactElement, useEffect } from 'react';
import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { useConnection } from 'modules/auth/hooks/useConnection';
import successImage from 'modules/common/assets/stake-success.png';
import { SuccessDialogContent } from 'modules/common/components/SuccessDialogContent/SuccessDialogContent';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { useTranslation } from 'modules/i18n';
import { useGetPoolQuery } from 'modules/pool/actions/getPool';

import { useEditPoolMutation } from '../../actions/editPool';
import { EditPoolForm } from '../EditPoolForm';
import { translation } from './translation';

interface IEditPoolContentProps {
  poolAddress: Address;
}

export function EditPoolContent({
  poolAddress,
}: IEditPoolContentProps): ReactElement | null {
  const { t, keys } = useTranslation(translation);
  const { onClose } = useDialog(KnownDialogs.withdraw);
  const { isSafeAccount, cacheTime } = useConnection();

  const { data: pool } = useGetPoolQuery(
    { address: poolAddress },
    { refetchOnMountOrArgChange: cacheTime },
  );
  const [edit, { isLoading, data }] = useEditPoolMutation();

  useEffect(() => {
    if (!isLoading && data && isSafeAccount) {
      onClose();
    }
  }, [isLoading, data, isSafeAccount, onClose]);

  console.log('pool', pool);

  // if (!pool) {
  //   return null;
  // }

  if (!isLoading && data && !isSafeAccount) {
    return (
      <SuccessDialogContent
        buttonLabel={t(keys.buttonText)}
        image={successImage}
        title={t(keys.done)}
        onClose={onClose}
      />
    );
  }

  return (
    <EditPoolForm
      isSubmitLoading={isLoading}
      poolAddress={poolAddress}
      onSubmit={params =>
        edit({
          ...params,
          comission: new BigNumber(params.comission),
          poolAddress,
        })
      }
    />
  );
}
